/* 太史慈傳・第 3 章：麻保屯（建安初）
 * 北邊是麻保賊的屯（土牆圍起來，南面一座屯門，門上有木樓）；南邊是孫策的圍營，孫軍在屯外圍成一圈。
 * 屯門到圍營之間是一片空地，城頭的箭射得到。 */
export const TUN = { x: 3200, y: 1500, hw: 1000, hh: 600 };
const T = 36, N = TUN.y - TUN.hh, S = TUN.y + TUN.hh, Wx = TUN.x - TUN.hw, E = TUN.x + TUN.hw;
export const GATE = [TUN.x, S], LOU = [TUN.x, S - 40], CAMP = [3200, 3900], FRONT = [3200, 2600], ARROW_Y = 3650;
export default {
  id: 'taishici_mabao', name: '麻保', W: 6400, H: 4600, seed: 197,
  bases: [CAMP, [TUN.x, TUN.y]],
  walls: [[TUN.x, N, TUN.hw + T, T], [Wx, TUN.y, T, TUN.hh], [E, TUN.y, T, TUN.hh], [(Wx + GATE[0] - 200) / 2, S, (GATE[0] - 200 - Wx) / 2 + T, T], [(GATE[0] + 200 + E) / 2, S, (E - GATE[0] - 200) / 2 + T, T]],
  roads: [{ pts: [CAMP, FRONT, [GATE[0], GATE[1] + 220], [TUN.x, TUN.y]], w: 150 }],
  rocks: [[900, 1000, 380, 200], [5500, 1100, 380, 200], [800, 3600, 340, 180], [5600, 3700, 360, 180]],
  woods: 0.4,
  sight: 0.9,
  clearings: [[TUN.x, TUN.y, 900], [GATE[0], GATE[1] + 500, 900], [CAMP[0], CAMP[1], 600]],
  tents: [{ x: TUN.x, y: TUN.y - 100, n: 8, r: 420, chief: true, col: '#5a5040', flag: '麻' }, { x: CAMP[0], y: CAMP[1] + 80, n: 7, r: 400, chief: true, col: '#b8433a', flag: '孫' }],
};
